export default "__VITE_ASSET__ee059072__$_?nuxt_component=async__"